export default "__VITE_ASSET__ac5e62fb__"